import { useEffect, useRef } from "react";
import { getBalanceById } from "adminApi/RoomBookingApi/RoomBooking";

/**
 * useCustomerBalance
 *
 * Fetches a customer's outstanding balance whenever `customerId` changes,
 * and writes it into form values as:
 *
 *   values.balance = { balance }
 *
 * `balance` comes straight from customer_balance_ledger.balance (the
 * latest ledger row for that customer). Sign convention:
 *   balance > 0  => customer has CREDIT available
 *   balance < 0  => customer has an outstanding DUE
 *   balance = 0  => no previous balance
 *
 * A request-id guard prevents stale/out-of-order responses (e.g. from
 * rapidly switching customers) from overwriting newer data.
 */
const useCustomerBalance = ({ customerId, setValues,values }) => {
    const requestIdRef = useRef(0);

    useEffect(() => {
        const currentRequestId = ++requestIdRef.current;

        if (!customerId) {
            setValues((prev) => ({
                ...prev,
                avalible_balance: 0 ,
            }));
            return;
        }

        (async () => {
            try {
                const res = await getBalanceById(String(customerId));
                if (requestIdRef.current !== currentRequestId) return;

                const row = res?.data?.rows?.[0] || {};
                const parsedBalance = Number(row.balance ?? 0);

                setValues((prev) => ({
                    ...prev,
                    avalible_balance:  Number.isFinite(parsedBalance) ? parsedBalance : 0,
                }));
            } catch (err) {
                if (requestIdRef.current !== currentRequestId) return;
                console.error("Failed to load customer balance:", err);

                setValues((prev) => ({
                    ...prev,
                    avalible_balance: 0 ,
                }));
            }
        })();
    }, [customerId, setValues]);
};

export default useCustomerBalance;